import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, ICONS } from '../../../../../../libs/ui/src/lib/constants'

export const ButtonBuyAccommodationSubmit: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <Typography variant='bodyM'>{t('buttons.continue')}</Typography>
      <FontAwesomeIcon icon={ICONS.farArrowRight} color={COLORS.white} />
    </>
  )
}
